function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var L = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var C = function C(o, e, l) {
  return e in o ? L(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: l
  }) : o[e] = l;
},
    n = function n(o, e) {
  for (var l in e || (e = {})) {
    r.call(e, l) && C(o, l, e[l]);
  }

  if (t) {
    var _iterator = _createForOfIteratorHelper(t(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        d.call(e, l) && C(o, l, e[l]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as i from "react";

function v(o) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4601 8.28997L12.0001 5.82997L9.53014 8.28997C9.14014 8.67997 8.51014 8.67997 8.12014 8.28997C7.73014 7.89997 7.73014 7.26997 8.12014 6.87997L11.2901 3.69997C11.6801 3.30997 12.3101 3.30997 12.7001 3.69997L15.8701 6.87997C16.2601 7.26997 16.2601 7.89997 15.8701 8.28997C15.4801 8.67997 14.8501 8.67997 14.4601 8.28997ZM9.54014 15.71L12.0001 18.17L14.4701 15.72C14.8601 15.33 15.4901 15.33 15.8801 15.72C16.2701 16.11 16.2701 16.74 15.8801 17.13L12.7101 20.3C12.3201 20.69 11.6901 20.69 11.3001 20.3L8.13014 17.12C7.74014 16.73 7.74014 16.1 8.13014 15.71C8.52014 15.32 9.15014 15.32 9.54014 15.71Z",
    fill: "black"
  }));
}

export { v as ReactComponent };